import { DataTableType } from 'src/app/entity/data-table.enum';

export const getDateTableType = (name: string): DataTableType => {
    return name === DataTableType.Benchmark ? DataTableType.Benchmark : DataTableType.TimeSeries;
};
